import React from 'react';
import { sortBy, uniqBy } from 'lodash';
import moment from 'moment';

import { HistoryOrder } from '../../index';
import { formatStatus, getStatusColor } from '../../utils';
import { PaperTitle, OrderStatusesRow, Status } from './styles';
import { useI18n } from '~Hooks';

interface Props {
  order: HistoryOrder | undefined;
}

export const Order = (props: Props) => {
  const { i18n } = useI18n();
  const { order } = props;
  if (!order) return null;

  return (
    <>
      <PaperTitle>{i18n('History.Order')}</PaperTitle>
      <OrderStatusesRow>
        {uniqBy(sortBy(order.statusHistory, 'timestamp'), 'status').map(
          ({ timestamp, status }) => (
            <Status key={timestamp} color={getStatusColor(status)}>{`${formatStatus(
              status,
              i18n,
            )} ${moment(timestamp).format('H:mm')}`}</Status>
          ),
        )}
      </OrderStatusesRow>
    </>
  );
};
